/**
 * @nanokart/tryon-studio-sdk
 * Footer component - Privacy note + Powered by branding
 */

import React from 'react';
import { useTryOnConfig } from '../../core/TryOnProvider';

export interface FooterProps {
  className?: string;
  style?: React.CSSProperties;
  showPoweredBy?: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  className,
  style,
  showPoweredBy = true,
}) => {
  const { config } = useTryOnConfig();
  const showBranding = showPoweredBy && config.brandingConfig?.showPoweredBy !== false;

  return (
    <footer
      className={className}
      style={{
        padding: '16px',
        textAlign: 'center',
        borderTop: '1px solid #f1f5f9',
        backgroundColor: '#f8fafc',
        flexShrink: 0,
        ...style,
      }}
      data-testid="studio-footer"
    >
      <p
        style={{
          margin: '0 0 8px',
          fontSize: '11px',
          color: '#94a3b8',
          maxWidth: '400px',
          marginLeft: 'auto',
          marginRight: 'auto',
          lineHeight: 1.5,
        }}
        data-testid="footer-privacy"
      >
        Your photo and try-on output remain private and visible only to you. All data is auto-deleted after the session.
      </p>

      {showBranding && (
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}
          data-testid="powered-by"
        >
          <span style={{ fontSize: '11px', color: '#94a3b8' }}>Powered by</span>
          <span style={{ fontSize: '12px', fontWeight: 600, color: '#64748b' }}>Nanokart</span>
        </div>
      )}
    </footer>
  );
};

export default Footer;
